module.exports = __webpack_public_path__ + "img/web-P4-0.ec13bbc7.png";